<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right">
            <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
            <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="listLoading" style="width: 100%; margin-top: 20px;" height="100%">
                <el-table-column prop="Name" label="时段名称" min-width="120" />
                <el-table-column label="时间" min-width="120">
                    <template slot-scope="scope">
                        {{ scope.row.StartTime || '-' }} ~ {{ scope.row.EndTime || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="SortOrder" label="排序" width="80" align="center" />
                <el-table-column label="校区" min-width="100">
                    <template slot-scope="scope">
                        {{ scope.row.CampusId > 0 ? getCampusName(scope.row.CampusId) : '—' }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.IsEnabled ? 'success' : 'info'">
                            {{ scope.row.IsEnabled ? '启用' : '停用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" width="160" align="center" />
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="warning" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" :type="scope.row.IsEnabled ? 'info' : 'success'"
                            @click="toggleEnabled(scope.row)">
                            {{ scope.row.IsEnabled ? '停用' : '启用' }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>

            <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="480px" :close-on-click-modal="false">
                <el-form :model="editForm" label-width="100px" :rules="rules" ref="editForm">
                    <el-form-item label="时段名称" prop="Name">
                        <el-input v-model="editForm.Name" maxlength="50" placeholder="如：上午" />
                    </el-form-item>
                    <el-form-item label="开始时间" prop="StartTime">
                        <el-time-select v-model="editForm.StartTime" placeholder="请选择开始时间" style="width: 100%"
                            :picker-options="{ start: '06:00', step: '00:05', end: '23:55' }"
                            @change="onStartTimeChange" />
                    </el-form-item>
                    <el-form-item label="结束时间" prop="EndTime">
                        <el-time-select v-model="editForm.EndTime" placeholder="请选择结束时间" style="width: 100%"
                            :picker-options="{ start: '06:00', step: '00:05', end: '23:55' }" />
                    </el-form-item>
                    <el-form-item label="排序" prop="SortOrder">
                        <el-input-number v-model="editForm.SortOrder" :min="0" :max="9999" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="editForm.CampusId" placeholder="请选择校区" style="width: 100%"
                            :disabled="!campusOptions.length">
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="启用">
                        <el-switch v-model="editForm.IsEnabled" />
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="editVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitEdit" :loading="editLoading">确 定</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import { getClassRollCallTimeSlotList, saveClassRollCallTimeSlot, setClassRollCallTimeSlotEnabled, getCampusList } from '../../api/modules/misc';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from "../../components/DepartmentPane";

export default {
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            filters: { campusId: null },
            searchList: [
                {
                    label: "筛选校区",
                    key: "campusId",
                    type: "select",
                    clearable: true,
                    options: [],
                },
            ],
            buttonList: [],
            DepartmentId: 0,
            campusOptions: [],
            rows: [],
            listLoading: false,
            editVisible: false,
            editLoading: false,
            dialogTitle: "",
            editForm: {
                Id: 0,
                SchoolId: 0,
                Name: "",
                StartTime: "",
                EndTime: "",
                SortOrder: 0,
                CampusId: null,
                IsEnabled: true,
            },
            rules: {
                Name: [{ required: true, message: "请输入时段名称", trigger: "blur" }],
                StartTime: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == null || String(value).trim() === "") {
                                callback(new Error("请选择开始时间"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
                EndTime: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == null || String(value).trim() === "") {
                                callback(new Error("请选择结束时间"));
                                return;
                            }
                            const st = this.editForm.StartTime;
                            if (st != null && String(st).trim() !== "") {
                                if (this.compareHHmm(String(st).trim(), String(value).trim()) >= 0) {
                                    callback(new Error("结束时间须晚于开始时间"));
                                    return;
                                }
                            }
                            callback();
                        },
                        trigger: "change",
                    },
                ],
                CampusId: [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value == null || value === "" || value <= 0) {
                                callback(new Error("请选择校区"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change",
                    },
                ],
            },
        };
    },
    methods: {
        /** @returns {number} 负数表示 a 早于 b，0 相等，正数 a 晚于 b */
        compareHHmm(a, b) {
            const pa = String(a).split(":").map((x) => parseInt(x, 10) || 0);
            const pb = String(b).split(":").map((x) => parseInt(x, 10) || 0);
            const ma = pa[0] * 60 + (pa[1] || 0);
            const mb = pb[0] * 60 + (pb[1] || 0);
            return ma - mb;
        },
        onStartTimeChange() {
            this.$nextTick(() => {
                if (this.$refs.editForm && this.editForm.EndTime) {
                    this.$refs.editForm.validateField("EndTime");
                }
            });
        },
        treeNodeClick(data) {
            this.DepartmentId = data.value;
            this.clearCampusFilter();
            this.loadCampusOptions();
            this.loadRows();
        },
        callFunction(item) {
            if (typeof item.search === "object") {
                this.filters = item.search;
            } else {
                this.filters = { campusId: null };
            }
            const fn = this[item.Func];
            if (fn) fn.call(this, item);
        },
        /** 取顶部当前学校 ID。最后更新：2026-08-30 */
        resolveSchoolId() {
            const candidates = [
                this.$store.state.activeSchoolId,
                typeof window !== "undefined" ? window.localStorage.getItem("activeSchoolId") : "",
                this.DepartmentId,
            ];
            return candidates.find((id) => /^\d+$/.test(String(id || "")) && String(id) !== "0") || "";
        },
        clearCampusFilter() {
            this.filters = { ...(this.filters || {}), campusId: null };
            this.campusOptions = [];
            const campusSearch = this.searchList.find((e) => e.key === "campusId");
            if (campusSearch) campusSearch.options = [];
            if (this.$refs.toolbar && this.$refs.toolbar.searchObj) {
                this.$set(this.$refs.toolbar.searchObj, "campusId", null);
            }
        },
        /** 顶部学校切换后重载校区与列表。最后更新：2026-08-30 */
        onActiveSchoolChange(newSchoolId, oldSchoolId) {
            if (String(newSchoolId || "") === String(oldSchoolId || "")) return;
            const schoolId = this.resolveSchoolId();
            this.DepartmentId = schoolId ? Number(schoolId) || schoolId : 0;
            this.clearCampusFilter();
            this.rows = [];
            this.editVisible = false;
            this.loadCampusOptions();
            if (schoolId) this.loadRows();
        },
        loadCampusOptions() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.campusOptions = [];
                const s = this.searchList.find((e) => e.key === "campusId");
                if (s) s.options = [];
                return;
            }
            getCampusList({ page: 1, intPageSize: 999, departmentId: schoolId }).then((res) => {
                if (String(schoolId) !== String(this.resolveSchoolId())) return;
                if (res.data.success) {
                    this.campusOptions = res.data.response.data || [];
                    const campusSearch = this.searchList.find((e) => e.key === "campusId");
                    if (campusSearch) {
                        campusSearch.options = this.campusOptions.map((e) => ({
                            label: e.Name,
                            value: e.Id,
                        }));
                    }
                }
            });
        },
        getCampusName(id) {
            if (!id) return "-";
            const c = this.campusOptions.find((x) => x.Id === id);
            return c ? c.Name : id;
        },
        loadRows() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.rows = [];
                return;
            }
            this.listLoading = true;
            let campusId = -1;
            if (this.filters.campusId != null && this.filters.campusId !== "" && this.filters.campusId > 0) {
                campusId = this.filters.campusId;
            }
            getClassRollCallTimeSlotList({ schoolId, campusId })
                .then((res) => {
                    this.listLoading = false;
                    if (res.data.success) {
                        this.rows = res.data.response || [];
                    }
                })
                .catch(() => {
                    this.listLoading = false;
                });
        },
        handleQuery() {
            this.loadRows();
        },
        handleAdd() {
            const schoolId = this.resolveSchoolId();
            if (!schoolId) {
                this.$message.warning("请先在顶部选择学校");
                return;
            }
            if (!this.campusOptions.length) {
                this.$message.warning("该校暂无校区数据，无法新增时段");
                return;
            }
            this.dialogTitle = "新增时段";
            this.editForm = {
                Id: 0,
                SchoolId: schoolId,
                Name: "",
                StartTime: "",
                EndTime: "",
                SortOrder: (this.rows && this.rows.length) ? this.rows.length + 1 : 1,
                CampusId: this.filters.campusId > 0 ? this.filters.campusId : null,
                IsEnabled: true,
            };
            this.editVisible = true;
            this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
        },
        handleEdit(row) {
            this.dialogTitle = "编辑时段";
            this.editForm = {
                Id: row.Id,
                SchoolId: row.SchoolId,
                Name: row.Name,
                StartTime: row.StartTime || "",
                EndTime: row.EndTime || "",
                SortOrder: row.SortOrder,
                CampusId: row.CampusId,
                IsEnabled: row.IsEnabled,
            };
            this.editVisible = true;
            this.$nextTick(() => this.$refs.editForm && this.$refs.editForm.clearValidate());
        },
        submitEdit() {
            this.$refs.editForm.validate((ok) => {
                if (!ok) return;
                this.editLoading = true;
                const para = { ...this.editForm };
                saveClassRollCallTimeSlot(para)
                    .then((res) => {
                        this.editLoading = false;
                        if (res.data.success) {
                            this.$message.success(res.data.msg || "保存成功");
                            this.editVisible = false;
                            this.loadRows();
                        } else {
                            this.$message.error(res.data.msg || "保存失败");
                        }
                    })
                    .catch(() => {
                        this.editLoading = false;
                    });
            });
        },
        toggleEnabled(row) {
            const enabled = !row.IsEnabled;
            this.$confirm(`确认${enabled ? "启用" : "停用"}该时段？`, "提示", { type: "warning" }).then(() => {
                setClassRollCallTimeSlotEnabled({ id: row.Id, enabled }).then((res) => {
                    if (res.data.success) {
                        this.$message.success("已更新");
                        this.loadRows();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                });
            });
        },
    },
    watch: {
        "$store.state.activeSchoolId"(newSchoolId, oldSchoolId) {
            this.onActiveSchoolChange(newSchoolId, oldSchoolId);
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        if (!this.buttonList.some((b) => b.Func === "handleQuery")) {
            this.buttonList.unshift({ name: "查询", Func: "handleQuery", id: 999 });
        }
        if (!this.buttonList.some((b) => b.Func === "handleAdd")) {
            this.buttonList.push({ name: "新增", Func: "handleAdd", id: 998 });
        }
        this.loadCampusOptions();
    },
};
</script>

<style scoped>
.dp-layout {
    display: flex;
    height: 100%;
}
.dp-left {
    width: 260px;
    flex-shrink: 0;
    margin-right: 12px;
}
.dp-right {
    flex: 1;
    min-width: 0;
}
</style>
